import React from "react";
import DistributionsOptionsFormFields from "./DistributionsOptionsFormFields";
import FeesFields from "./FeesFields";
import { AddHierarchy, LoanDocumentCard } from "../../../components";
import SourceApplicableTable from "./SourceApplicableTable";
import DistributionAllocationMethodsFields from "./DistributionAllocationMethodsFields";

const ForceOutForm = (props) => {
  const { isSave, isEdit, fields } = props;

  return (
    <div>
      <DistributionsOptionsFormFields {...props} />
      <SourceApplicableTable {...props} />
      <DistributionAllocationMethodsFields {...props} />
      <FeesFields {...props} />
      <LoanDocumentCard
        {...props}
        fields={fields}
        isEdit={isEdit}
        isSave={isSave}
        fieldArrayName={fields.withdrawalDocumentType}
      />

      <AddHierarchy {...props} />
    </div>
  );
};

export default ForceOutForm;
